@if (hasFilesInQueue) {
  <div data-cy="upload-receipt-overlay" class="container" [class.compressed]="!displayContent">
    <div class="header row">
      <div>
        <div class="toggle-content-icon" (click)="toggleContentDisplay()">
          @if (!displayContent) {
            <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-chevron-left"></mat-icon>
          }
          @if (displayContent) {
            <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-chevron-right"></mat-icon>
          }
        </div>
        <span data-cy="upload-receipt-overlay-header">{{ headerDescription }}</span>
      </div>
      @if (isDoneUploading) {
        <div>
          <button
            data-cy="upload-receipt-overlay-show-list-btn"
            tiime-button
            color="primary"
            raised
            (click)="emitNavigate()"
          >
            Voir la liste
          </button>
          <mat-icon
            class="closing-icon"
            inline="true"
            fontSet="fontastic"
            fontIcon="icon-ic-close-r"
            (click)="emitCloseOverlay()"
          ></mat-icon>
        </div>
      }
      @if (hasPendingUpload && !displayContent) {
        <span>{{ countPendingUploadingFiles }} / {{ currentFiles.length }}</span>
      }
    </div>
    @for (uploadReceiptFile of currentFiles; track trackByIndex($index)) {
      <div class="row">
        @switch (uploadReceiptFile.uploadStatus) {
          @case (UploadFileStatus.NOT_STARTED) {
            <div class="file in-progress">
              <span class="filename">{{ uploadReceiptFile.name }}</span>
              <tiime-progress-spinner-loader
                diameter="20"
                color="primary"
                mode="determinate"
                [value]="uploadReceiptFile.progress"
              ></tiime-progress-spinner-loader>
            </div>
          }
          @case (UploadFileStatus.IN_PROGRESS) {
            <div class="file in-progress">
              <span class="filename">{{ uploadReceiptFile.name }}</span>
              <tiime-progress-spinner-loader
                diameter="20"
                color="primary"
                mode="determinate"
                [value]="uploadReceiptFile.progress"
              ></tiime-progress-spinner-loader>
            </div>
          }
          @case (UploadFileStatus.ON_ERROR) {
            <div class="file on-error">
              <span class="filename">{{ uploadReceiptFile.name }}</span>
              <span
                class="error-mesage"
                tiimeTooltip
                [tooltipContent]="errorMessageTooltipTemplate"
                tooltipClass="tiime-tooltip"
                tooltipHideWithoutEllipsis
              >
                {{ uploadReceiptFile.error }}
              </span>
              <ng-template #errorMessageTooltipTemplate>
                <div class="tiime-tooltip-content">
                  {{ uploadReceiptFile.error }}
                </div>
              </ng-template>
              <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-alerte-input"></mat-icon>
            </div>
          }
          @case (UploadFileStatus.COMPLETED) {
            <div class="file completed">
              <div>
                <img class="upload-receipt-icon" src="assets/uploaded_receipt.svg" alt="Upload completed" />
                <span class="filename">{{ uploadReceiptFile.name }}</span>
              </div>
              <mat-icon inline="true" fontSet="fontastic" fontIcon="icon-ic-select"></mat-icon>
            </div>
          }
        }
      </div>
    }
  </div>
}
